import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, money } from "../lib/api";
import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";

const CATS = ["Tümü", "Kart Setleri", "Kitaplar", "Dijital Ürünler", "Atölyeler", "Eğitimler", "Kurumsal Ürünler"];

export default function Store() {
  const [all, setAll] = useState([]);
  const [active, setActive] = useState("Tümü");

  useEffect(() => { api.get("/products").then(({ data }) => setAll(data)).catch(() => {}); }, []);
  const items = active === "Tümü" ? all : all.filter((p) => p.category === active);

  return (
    <>
      <Seo title="Bilgece Mağaza" description="Bilgece kart setleri, kitaplar ve dijital ürünler. Bilgece Ebeveyn Kartları — 52 Kart ve daha fazlası." />
      <section className="pt-36 pb-14 bg-brand-green text-brand-offwhite grain relative overflow-hidden">
        <div className="container-narrow px-6 lg:px-10">
          <p className="text-xs uppercase tracking-[0.25em] text-brand-gold font-semibold mb-4">Bilgece Mağaza</p>
          <h1 className="font-serif text-4xl md:text-6xl font-light">Bilgece ürünler</h1>
          <p className="text-brand-offwhite/75 mt-5 max-w-2xl leading-relaxed">Bilgeliği eve ve sınıfa taşıyan kart setleri, kitaplar ve dijital ürünler.</p>
        </div>
      </section>

      <section className="pt-12 pb-24 px-6 sm:px-10 lg:px-16 bg-brand-offwhite">
        <div className="container-narrow">
          <div className="flex flex-wrap gap-2 mb-12">
            {CATS.map((c) => (
              <button key={c} onClick={() => setActive(c)} data-testid={`store-filter-${c}`}
                className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors ${active === c ? "bg-brand-green text-brand-offwhite border-brand-green" : "bg-brand-cream text-brand-text/70 border-brand-gold-light/40 hover:border-brand-gold"}`}>{c}</button>
            ))}
          </div>
          {items.length === 0 && <p className="text-brand-text/60" data-testid="store-empty">Bu kategoride ürün yok.</p>}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {items.map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 0.08}>
                <Link to={`/magaza/${p.slug}`} data-testid={`product-card-${p.slug}`}
                  className="group block h-full bg-brand-cream border border-brand-gold-light/40 rounded-sm overflow-hidden transition-transform duration-300 hover:-translate-y-1.5 hover:border-brand-gold">
                  <div className="h-52 overflow-hidden relative">
                    <img src={p.cover} alt={p.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    {p.sale_price && <span className="absolute top-3 left-3 bg-brand-gold text-brand-offwhite text-xs px-2 py-1 rounded">İndirim</span>}
                  </div>
                  <div className="p-6">
                    <span className="text-xs uppercase tracking-[0.2em] text-brand-gold font-semibold">{p.category}</span>
                    <h3 className="font-serif text-2xl text-brand-green mt-2 leading-tight">{p.name}</h3>
                    <p className="text-brand-text/65 text-sm mt-2 line-clamp-3">{p.short_description}</p>
                    <div className="mt-4 flex items-center gap-2">
                      {p.sale_price ? <>
                        <span className="text-brand-green font-semibold text-lg">{money(p.sale_price)}</span>
                        <span className="text-brand-text/40 line-through text-sm">{money(p.price)}</span>
                      </> : <span className="text-brand-green font-semibold text-lg">{money(p.price)}</span>}
                    </div>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
